import styled from '@emotion/styled'

export const InsightCardChartWrapper = styled.div`
  min-width: 100%;
  height: 250px;
`

export const InsightCardTableWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px 0;
`
